/**
 * Centralized field labels for the Matrimony profile forms, edit modals, and details page.
 */

export const FIELD_LABELS = {
  // ── Step 1 / Personal ──────────────────────────────────────────────
  ADD_A_PHOTO: "Add a Photo",
  FULL_NAME: "Full Name",
  DATE_OF_BIRTH: "Date of Birth",
  EMAIL_ID: "Email ID",
  MOBILE_NUMBER: "Mobile Number",
  GENDER: "Gender",
  MARITAL_STATUS: "Marital Status",
  TIME_OF_BIRTH: "Time of Birth",
  RELIGION: "Religion",
  ABOUT: "About",
  CASTE_DETAILS: "Caste Details",
  PROFILE_PHOTO: "Profile Photo (optional)",

  // ── Step 2 / Professional ──────────────────────────────────────────
  HIGHEST_EDUCATION: "Highest Education",
  COLLEGE_UNIVERSITY: "College / University",
  EMPLOYMENT_SECTOR: "Employment Sector",
  DESIGNATION: "Designation",
  EMPLOYER_NAME: "Employer Name",
  ANNUAL_INCOME: "Annual Income",
  SOCIAL_MEDIA_LINKS: "Social Media Links",
  PLATFORM: "Platform",
  URL: "URL",

  // ── Step 3 / Family ────────────────────────────────────────────────
  FATHER_NAME: "Father's Name",
  MOTHER_NAME: "Mother's Name",
  FATHER_OCCUPATION: "Father's Occupation",
  MOTHER_OCCUPATION: "Mother's Occupation",
  FAMILY_TYPE: "Family Type",
  FAMILY_STATUS: "Family Status",
  NATIVE_PLACE: "Native Place",
  TOTAL_FAMILY_MEMBERS: "Total Family Members",

  // ── Step 4 / Lifestyle ─────────────────────────────────────────────
  HEIGHT_CM: "Height (in Centimetres)",
  BODY_TYPE: "Body Type",
  SKIN_TONE: "Skin Tone",
  SMOKING_HABIT: "Smoking Habit",
  DRINKING_HABIT: "Drinking Habit",
  DIETARY_HABITS: "Dietary Habits",
  HOBBIES_INTERESTS: "Hobbies & Interests",
  OWNS_HOUSE: "Owns House",

  // ── Step 5 / Horoscope ─────────────────────────────────────────────
  NAKSHATRA: "Nakshatra (Star)",
  RASI: "Rasi (Moon Sign)",
  GOTHRAM: "Gothram",
  DOSHAM: "Dosham",

  // ── Details page section titles ────────────────────────────────────
  COMPANY: "Company",
  COLLEGE: "College",
  DIET: "Diet",
  DRINKING: "Drinking",
  SMOKING: "Smoking",
} as const;
